import { ThemeProvider, createTheme } from "@mui/material";
import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "../Views/Pages/Main";
import Token from "../Views/Pages/Token";
import About from "../Views/Pages/About";
import Roadmap from "../Views/Pages/Roadmap";
import ComingSoon from "../Views/Components/ComingSoon";

const getActiveTheme = (themeMode) => {
  return createTheme({
    pageColor: themeMode === 'true' || !themeMode ? '#FBFBFF' : '#FBFBFF',
    // BackgroundColors
    bgPrimary: themeMode === 'true' || !themeMode ? '#fff' : '#fff',
    bgSecondary: themeMode === 'true' || !themeMode ? '#202124' : '#202124',
    bgTertiary: themeMode === 'true' || !themeMode ? '#323639' : '#323639',
    bgQuaternary: themeMode === 'true' || !themeMode ? '#F5F5F5' : '#F5F5F5',
    // TextColors
    textPrimary: themeMode === 'true' || !themeMode ? '#000' : '#000',
    textSecondary: themeMode === 'true' || !themeMode ? '#fff' : '#fff',
    Approvecolor: themeMode === 'true' || !themeMode ? '#86FBB0' : '#86FBB0',
    Defeatedcolor: themeMode === 'true' || !themeMode ? '#FF2424' : '#FF2424',
    //buttonColors
    btnPrimary: themeMode === 'true' || !themeMode ? '#00F1FF' : '#00F1FF',
    btnSecondary: themeMode === 'true' || !themeMode ? '#F94E9B' : '#F94E9B',
    btnDisable: themeMode === 'true' || !themeMode ? '#DAE8FB' : '#DAE8FB',
    tabDisable: themeMode === 'true' || !themeMode ? '#7D7D7F' : '#7D7D7F',
    btnTxtPrimary: themeMode === 'true' || !themeMode ? '#ffffff' : '#ffffff',
    btnPrimaryHover: themeMode === 'true' || !themeMode ? '#d3287d' : '#d3287d',
    // others
    switchColor: themeMode === 'true' || !themeMode ? '#161616' : '#efefef',
    // BG-Gradients
    BgGradientPrimary: themeMode === 'true' || !themeMode ? 'linear-gradient(156deg, rgba(56,56,56,1) 18%, rgba(0,0,0,1) 100%)' : 'linear-gradient(156deg, rgba(56,56,56,1) 18%, rgba(0,0,0,1) 100%)',
    BgGradientSecondary: themeMode === 'true' || !themeMode ? 'linear-gradient(156deg, rgba(255,255,255,1) 18%, rgba(242,242,244,1) 100%)' : 'linear-gradient(156deg, rgba(255,255,255,1) 18%, rgba(242,242,244,1) 100%)',
    BgGradientTertiary: themeMode === 'true' || !themeMode ? 'linear-gradient(156deg, rgba(78,150,255,1) 18%, rgba(3,101,245,1) 100%)' : 'linear-gradient(156deg, rgba(78,150,255,1) 18%, rgba(3,101,245,1) 100%)',
    BgGradientQuaternary: themeMode === 'true' || !themeMode ? 'linear-gradient(156deg, rgba(251,251,255,1) 18%, rgba(235,243,254,1) 100%)' : 'linear-gradient(156deg, rgba(251,251,255,1) 18%, rgba(235,243,254,1) 100%)',
    // Box Shadow
    BoxShadowPrimary: themeMode === 'true' || !themeMode ? '0px 0px 10px 3px rgb(0 0 0 / 5%)' : '0px 0px 10px 3px rgb(0 0 0 / 5%)',


  })
}
const ThemeContainer = () => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme(currentTheme));

  useEffect(() => {
    setActiveTheme(getActiveTheme(currentTheme))
  }, [currentTheme]);

  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<MainPage />} />
          <Route exact path="/token" element={<Token />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/developmenttimeline" element={<Roadmap />} />
          <Route exact path="/comingsoon" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default ThemeContainer;